export const ACCOUNT_STATUS = {
  ACTIVE: 'active',
  IN_NOTICE: 'in_notice',
  CANCELED: 'canceled',
  TEST: 'test',
  OTHERS: 'others'
}

export const CLOSED_ACCOUNT_ACTION_ERROR = 'Conta encerrada: esta ação não está disponível.'

export const ACCOUNT_STATUS_OPTIONS = [
  { value: 'active', label: 'Ativa' },
  { value: 'in_notice', label: 'Em aviso prévio' },
  { value: 'canceled', label: 'Cancelada' },
  { value: 'test', label: 'Teste' },
  { value: 'others', label: 'Outros' }
]

const LABELS = ACCOUNT_STATUS_OPTIONS.reduce((acc, o) => {
  acc[o.value] = o.label
  return acc
}, {})

const BADGE_CLASSES = {
  active: 'badge-success',
  in_notice: 'badge-warning',
  canceled: 'badge-danger',
  test: 'badge-info',
  others: 'badge-secondary'
}

export function translateAccountStatus(value) {
  if (!value)
    return '-'

  return LABELS[value] || value
}

export function accountStatusBadgeClass(value) {
  return BADGE_CLASSES[value] || 'badge-secondary'
}

export function isAccountStatusOption(value) {
  return ACCOUNT_STATUS_OPTIONS.some(o => o.value === value)
}
